import { render, staticRenderFns } from "./salesManage.vue?vue&type=template&id=1968362e&"
import script from "./salesManage.vue?vue&type=script&lang=js&"
export * from "./salesManage.vue?vue&type=script&lang=js&"
import style0 from "./salesManage.vue?vue&type=style&index=0&id=1968362e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports